import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isEditMode", "isNewFile", "id", "assetId", "fileName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import OverflowTooltip from 'components/OverflowTooltip';
import AssetDownloadLink from 'components/AssetDownloadLink';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx } from "react/jsx-runtime";
var FileNameField = function FileNameField(_ref) {
  var isEditMode = _ref.isEditMode,
    isNewFile = _ref.isNewFile,
    id = _ref.id,
    assetId = _ref.assetId,
    fileName = _ref.fileName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    label: t('form_file_name_colon'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: isEditMode ? /*#__PURE__*/_jsx(OverflowTooltip, {
      content: fileName,
      children: /*#__PURE__*/_jsx(Box, {
        overflow: "ellipsis",
        children: isNewFile || !assetId ? fileName : /*#__PURE__*/_jsx(AssetDownloadLink, {
          assetId: assetId,
          children: fileName
        })
      })
    }) : /*#__PURE__*/_jsx(OverflowTooltip, {
      content: fileName,
      children: fileName
    })
  }));
};
export default FileNameField;